import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  en: {
    kiosk: {
      welcome: "Welcome",
      sign_in: "Sign In",
      sign_out: "Sign Out",
      visitor_type_choose: "What's the reason for your visit?",
      type_visitor: "Visitor",
      type_contractor: "Contractor",
      type_delivery: "Delivery",
      type_interview: "Interview",
      type_other: "Other",
      name: "Full name",
      company: "Company",
      email: "Email",
      phone: "Phone",
      purpose: "Purpose of visit",
      vehicle_reg: "Vehicle registration",
      host: "Who are you visiting?",
      host_select: "Select a host",
      photo: "Photo",
      photo_capture: "Take photo",
      photo_skip: "Skip photo (DEV)",
      photo_retake: "Retake",
      signature: "Signature",
      sign_here: "Please sign here",
      clear: "Clear",
      consent_title: "Consents",
      i_accept: "I accept",
      next: "Next",
      back: "Back",
      submit: "Sign me in",
      success_title: "You're signed in",
      success_subtitle: "Your host has been notified",
      sign_out_by_name: "Find your name",
      sign_out_by_qr: "Scan your badge QR",
      sign_out_by_pin: "Enter your 4-digit PIN",
      pin_placeholder: "PIN",
      sign_out_success: "You're signed out — see you next time",
      go_back: "Go back",
      cancel: "Cancel",
      idle_lock: "Touch the screen to start",
      tap_to_start: "Tap to begin",
      page_unpaired_title: "This kiosk isn't paired yet",
      page_unpaired_body: "Ask your administrator for the pairing PIN.",
      enter_pin: "Enter pairing PIN",
      pair: "Pair this device",
      lookup_returning: "Use my saved details",
      lookup_email: "Email or phone (returning visitor)",
      sign_out_search_placeholder: "Type your name…",
      no_results: "No matches yet — keep typing.",
      mocked_resend: "MOCKED — Resend",
    },
  },
  de: {
    kiosk: {
      welcome: "Willkommen",
      sign_in: "Anmelden",
      sign_out: "Abmelden",
      visitor_type_choose: "Was ist der Grund Ihres Besuchs?",
      type_visitor: "Besucher",
      type_contractor: "Auftragnehmer",
      type_delivery: "Lieferung",
      type_interview: "Interview",
      type_other: "Sonstiges",
      name: "Vollständiger Name",
      company: "Firma",
      email: "E-Mail",
      phone: "Telefon",
      purpose: "Zweck des Besuchs",
      vehicle_reg: "Kfz-Kennzeichen",
      host: "Wen besuchen Sie?",
      host_select: "Gastgeber auswählen",
      photo: "Foto",
      photo_capture: "Foto aufnehmen",
      photo_skip: "Foto überspringen (DEV)",
      photo_retake: "Erneut",
      signature: "Unterschrift",
      sign_here: "Bitte hier unterschreiben",
      clear: "Löschen",
      consent_title: "Einwilligungen",
      i_accept: "Ich akzeptiere",
      next: "Weiter",
      back: "Zurück",
      submit: "Anmelden",
      success_title: "Sie sind angemeldet",
      success_subtitle: "Ihr Gastgeber wurde benachrichtigt",
      sign_out_by_name: "Namen suchen",
      sign_out_by_qr: "Badge-QR scannen",
      sign_out_by_pin: "4-stelligen PIN eingeben",
      pin_placeholder: "PIN",
      sign_out_success: "Sie sind abgemeldet — bis zum nächsten Mal",
      go_back: "Zurück",
      cancel: "Abbrechen",
      idle_lock: "Bildschirm berühren, um zu starten",
      tap_to_start: "Zum Starten tippen",
      page_unpaired_title: "Dieses Kiosk ist nicht gekoppelt",
      page_unpaired_body: "Bitten Sie Ihren Administrator um die Kopplungs-PIN.",
      enter_pin: "Kopplungs-PIN eingeben",
      pair: "Dieses Gerät koppeln",
      lookup_returning: "Gespeicherte Daten verwenden",
      lookup_email: "E-Mail oder Telefon",
      sign_out_search_placeholder: "Geben Sie Ihren Namen ein…",
      no_results: "Noch keine Treffer.",
      mocked_resend: "MOCKED — Resend",
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    ns: ["kiosk"],
    defaultNS: "kiosk",
    interpolation: { escapeValue: false },
  });

export default i18n;
